module.exports = __webpack_public_path__ + "static/023ba4df01e2b9f33e9bb9f97e5fe29a474425733c956ee625c6033c065245dc-15e2c7ead3d7fe5f15f0265b2867b545.jpeg";